<script setup>
  import { computed, ref } from "vue";
  import { EmptyState } from "@/components/episto-ui/empty-state";
  import CommentsStatusSwitch from "./CommentsStatusSwitch.vue";
  import NewThreadComposer from "./NewThreadComposer.vue";
  import ReviewThreadCard from "./ReviewThreadCard.vue";
  import { useReviewCommentsStore } from "@stores/survey/reviewComments";

  const props = defineProps({ card: { type: Object, required: true } });

  const store = useReviewCommentsStore();
  const status = ref("open");

  const threads = computed(() =>
    store.threadsForCard(props.card.token).filter((thread) => thread.status === status.value),
  );
</script>

<template>
  <div
    class="flex min-h-0 flex-1 flex-col"
    data-cy="edit-card-comments">
    <div class="flex min-h-0 flex-1 flex-col gap-2 overflow-y-auto p-3">
      <CommentsStatusSwitch v-model="status" />
      <ReviewThreadCard
        v-for="thread in threads"
        :key="thread.id"
        :thread="thread" />
      <EmptyState
        v-if="!threads.length"
        size="sm"
        :title="status === 'open' ? 'No open comments on this card.' : 'No resolved comments on this card.'" />
    </div>
    <NewThreadComposer
      v-if="status === 'open'"
      :target="card.name || 'this card'"
      @submit="(body, mentions) => store.createThread(card.token, body, mentions)" />
  </div>
</template>
